<template>
  <div id="reportingSearchBar" ref="reportingSearchBar">
    <div :class="{'search-bar-content': true}">
      <!-- Show search options -->
      <div v-if="!enableSearchOptions && (searchTextVal.length < 1 && playerStatusSelected.length < 1)"
        @click="handleSearchIconClick"
        :class="{'search-icon show-search-options-action prevent-confirmed-search': true, 'no-playerlist-history': (presentReportByBatch.length < 1) }">
      </div>

      <!-- Search options -->
      <div v-if="enableSearchOptions" onclick="event.stopPropagation()" class="search-content unconfirmed-search prevent-confirmed-search">
        <el-input
          id="player-reporting-search-input"
          :model-value="searchTextVal"
          @update:model-value="newValue => searchTextVal = newValue"
          ref="playerSearchInput"
          :placeholder="$t('label.search')"
          class="search-input">
        </el-input>
      </div>

      <!-- Search value -->
      <div v-if="!enableSearchOptions && (searchTextVal.length > 0 || playerStatusSelected.length > 0)" class="search-content confirmed-search">
        <div v-if="searchTextVal.length > 0" class="confirmed-search-group-container text-group">
          <div @mouseover="mouseOverConfirmedText = true"
            @mouseout="mouseOverConfirmedText = false" :class="{'confirmed-search-group-container-content': true, 'mouse-over': mouseOverConfirmedText}">
            <div class="keyword" v-if="searchTextVal.trim().length > 0"> {{ searchTextVal }} </div>
            <div @click="handleResetSearchValue" class="remove-search-value"></div>
            <div @click="handleConfirmedTextValueClick" class="text-val-cover">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./reporting-search-bar.js"></script>
<style lang="scss" src="./reporting-search-bar.scss"></style>
